<template>
  <div class="container-fluid" v-if="authorised" style="z-index: 99999">
    <div class="row nav-container">
<!--      <div class="col-12">-->
<!--      <img class="logo-container" src="https://borium.s3.eu-west-2.amazonaws.com/beible/beible-logo-blue.png" height="80px">-->
        <ul>
<!--          <li><router-link to="/home" exact >홈</router-link></li>-->

<!--          <li><router-link to="/report">분석</router-link></li>-->
  <!--        <li><router-link to="/pos">판매</router-link></li>-->
<!--          <li><router-link to="/express" exact >특송</router-link></li>-->
          <li><router-link to="/moveJobs" exact >이사</router-link></li>
          <li><router-link to="/calendar" exact >달력</router-link></li>
          <li><router-link to="/manifests" exact >Manifests</router-link></li>
<!--          <li><router-link to="/orders" exact >주문</router-link></li>-->
<!--          <li><router-link to="/products">상픔</router-link></li>-->

  <!--        <li><router-link to="/purchase">구매</router-link></li>-->
          <li class="hide-mobile"><router-link to="/sales">매출</router-link></li>
          <li class="hide-mobile"><router-link to="/customers">청구처</router-link></li>
          <li class="hide-mobile"><router-link to="/airlines">항공사</router-link></li>
          <li class="hide-mobile"><router-link to="/setting">설정</router-link></li>
          <li class="hide-mobile"><router-link to="/company">회사정보</router-link></li>
          <li>
            <i class="fas fa-sign-out-alt logout-btn" v-on:click="logout"></i>
          </li>
        </ul>
<!--      </div>-->
    </div>
    <v-dialog/>
    <transition name="slideup">
      <div class="item-container" style="z-index:999" v-if="pdfView != false" v-on:click="pdfView = false">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
          <div style="width:100%; height:100%; padding-top:10px;">
            <embed :src="pdfView.src" style="width: 90%; height: calc(100% - 20px); margin:auto" type="application/pdf"/>
          </div>
        </div>
      </div>
    </transition>
    <transition name="dissolve">
      <div class="progressView" v-if="isLoading==true">
        <div class="center-container">
          <div class="content-center">
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            <p class="loading-message"> {{loadingMessage}}</p>
          </div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
    import {getUserByToken} from "../api/user";

    require('@/assets/css/loading1.css')
    import Router from '../router';
    import EventBus from '../api/event-bus.js';
    export default {
        name: "TopNav",
        data() {
            return {
                authorised: false,
                isLoading:false,
                loadingMessage:'',
              pdfView: false,
            }
        },
        created() {
            EventBus.$on('logon', this.onLogged);
            EventBus.$on('showLoading', this.showLoading);
            EventBus.$on('showDialog', this.showDialog);
            EventBus.$on('sessionExpired', this.onExpired);
          EventBus.$on('showPDF', this.showPDF);
        },
        mounted() {
        },
        methods: {
          dummy: function() {

          },
            onLogged: function(logged) {
                console.log("logged on " + logged);
                this.$data.authorised = logged;
                let self = this;
                if(logged == false) {
                  this.onLogoutConfirmed();
                } else {
                  getUserByToken()
                    .then(function (user) {
                      self.$data.user = user;
                      auth.setUser(user);
                    })
                    .catch(function(err){

                    })
                  // this.$data.user = auth.getUser();
                  // console.log("logged on and get user ");
                  // console.log(this.$data.user);
                }

            },
            onExpired: function() {
              this.$data.authorised = false;
              this.$router.push('/');
            },
            logout: function () {
                let self = this;
                this.$modal.show('dialog', {
                    //title: '로그아웃',
                    text: '로그아웃 하시겠습니까?',
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '로그아웃',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.onLogoutConfirmed();
                            }
                        },

                    ]

                });
            },
            onLogoutConfirmed: function () {
                localStorage.removeItem("JSTOKEN");
                localStorage.removeItem("email");
                localStorage.removeItem("id");
                this.$data.authorised = false;
                Router.push('/');
            },
            showLoading: function(show) {
              this.$data.isLoading = show;
            },
            showDialog: function(params) {
              this.$modal.show('dialog', params);
            },
          showPDF: function(blob) {
            let self = this;
            let reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function() {
              let base64data = reader.result;
              self.$data.pdfView = {
                src: 'data:application/pdf;base64,' + base64data.replace("data:application/json;base64,", ""),
              }
            }
          },
        }
    }
</script>

<style lang="css" scoped>
  .nav-container {
    /*background: #333;*/
    /*margin-bottom: 20px;*/
    height: 50px;
    background-image: linear-gradient(#969797, black);
    position: relative;
  }
  ul {
    display: flex;
    list-style-type: none;
    margin: auto;
    position: absolute;
    bottom: 0;
    left:50%;
    transform: translateX(-50%);
    padding: 0;
    overflow: hidden;
    background-color: transparent;
  }

  li {
    float: left;
  }

  li a {
    display: block;
    color: white;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    min-width: 100px;
  }
  @media only screen and (max-width: 380px) {
    li a {
      min-width: 100px;
    }
  }
  /* Change the link color to #111 (black) on hover */

  li a:hover:not(.active) {
    text-decoration: none;
    background-color: #111;
    color: white;
  }
  .active {
    background-color: #4CAF50;
  }
  .logo-container {
    position: absolute;
    top:10px;
    left:50px;
  }
  .logout-btn {
    color:white;
    font-size:25px;
    line-height: 52px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .router-link:hover {

  }
  .router-link-active {
    background-color: #2b90d9;
    border-color: #1982ce;
    color: #fefefe;
  }
  .nav-container .logo {
    width:100px;
    height: 150px;
    position: absolute;
    left: 0;
    top: 0;
    background-image: url("/static/mace_logo.png");
    background-position: left;
    background-repeat: no-repeat;
    background-size: 100px 100px;
  }
  .item-container {
    position: fixed;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    /*float: left;*/
    /*width: calc(100% - 700px);*/
    /*height: 100%;*/
    /*overflow-y: scroll;*/
    /*background: green;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue